import * as React from 'react';
import Spinner from './Spinner';

export default class BlockingOverlay extends React.Component<{ show: boolean }, EmptyState> {

	constructor(props: { show: boolean }) {
		super(props);
	}

	render() {
		if (!this.props.show)
			return null;

		return <div className='blocking-overlay'>
			<Spinner />
		</div>;
	}
}
